<template>
  <div class="header">
    <img src="../assets/imgs/report_header.png" alt="" />
  </div>
  <div class="report">
    <div class="report_area">
      <div class="report_item" v-for="(item, index) of reportList" :key="index">
        <div class="file">
          <img
            :src="'http://103.5.193.60:3000/files' + item.avator"
            alt=""
            class="file_logo"
          />
        </div>
        <div class="right_data">
          <div class="des">2020中国网购市场监测报告_{{ item.title }}</div>
          <div class="download_button">
            <img
              src="../assets/imgs/report_download.png"
              @click="showModal(item.no)"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="more">
        <div class="button" @click="showModal(1)">更多报告</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { getReportList } from "@/api/http";
export default {
  components: {},
  setup() {
    const reportList = ref<any>([]);
    const showModal = (type: number) => {
      document.dispatchEvent(new CustomEvent("show_modal", { detail: type }));
    };
    onMounted(() => {
      getReportList().then((data) => {
        if (data.code === "0") {
          reportList.value = data.data
            .map((item: any) => {
              return { ...item, no: item.no * 1 };
            })
            .filter((item: any) => item.title === "茶饮料");
        }
      });
    });
    return {
      reportList,
      showModal,
    };
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 1200px;
  margin: 0 auto;
  font-size: 0px;
  img {
    width: 1920px;
    margin-left: -360px;
  }
}
.report {
  background: #fff;
  .report_area {
    width: 1200px;
    margin: 0 auto;
    padding: 68px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .report_item {
      width: 562px;
      display: flex;
      align-items: center;
      padding: 10px;
      box-shadow: 0 0 20px 1px #e6ebed;
      margin-top: 40px;
      .file {
        width: 136px;
        font-size: 0;
        position: relative;
        .file_logo {
          width: 100%;
        }
      }
      .right_data {
        margin-left: 24px;
        .des {
          font-size: 20px;
          color: #596675;
        }
        .download_button {
          margin-top: 24px;
          img {
            cursor: pointer;
          }
        }
      }
    }
  }
  .more {
    margin-top: 40px;
    margin-right:100px;
    .button {
      width: 168px;
      border: 1px solid #0072bd;
      color: #0072bd;
      font-size: 16px;
      letter-spacing: 2px;
      margin: 0 auto;
      text-align: center;
      line-height: 44px;
      cursor: pointer;
      font-weight: bold;
      transition: 0.3s all;
      &:hover {
        background: #0072bd;
        color: #fff;
      }
    }
  }
}
</style>
